var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "header" }, [_vm._v("新增岗位")]),
      _vm._v(" "),
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "岗位名称",
                prop: "name",
                rules: [
                  {
                    required: true,
                    message: "请输入岗位名称",
                    trigger: "blur"
                  },
                  {
                    max: 10,
                    message: "岗位名称不能超过10个字符",
                    trigger: "change"
                  }
                ]
              }
            },
            [
              _c("el-input", {
                attrs: { "show-word-limit": "", maxlength: "10" },
                model: {
                  value: _vm.form.name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "岗位描述",
                prop: "description",
                rules: [
                  {
                    required: true,
                    message: "请输入岗位描述",
                    trigger: "blur"
                  },
                  {
                    max: 50,
                    message: "岗位描述不能超过50个字符",
                    trigger: "change"
                  }
                ]
              }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  "show-word-limit": "",
                  maxlength: "50"
                },
                model: {
                  value: _vm.form.description,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("PermissionSelector", {
        attrs: {
          readonly: false,
          data: _vm.permissions,
          checkedKeys: _vm.checkedKeys
        },
        on: {
          submit: _vm.handleSubmit,
          cancel: _vm.handleCancel,
          reset: _vm.handleReset
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28dcb8c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28dcb8c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/positionPermissions/PositionsCreate.vue
// module id = null
// module chunks = 